import { render, staticRenderFns } from "./AssignUserIdDialog.vue?vue&type=template&id=152f941f&scoped=true&"
import script from "./AssignUserIdDialog.vue?vue&type=script&lang=js&"
export * from "./AssignUserIdDialog.vue?vue&type=script&lang=js&"
import style0 from "./AssignUserIdDialog.vue?vue&type=style&index=0&id=152f941f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152f941f",
  null
  
)

export default component.exports